module.exports = __webpack_public_path__ + "static/saas-f9976e58cb444858921a79a3c7486842.svg";